const departments = {
	1:  { description: "Sales"},
	2:  { description: "Engineering"},
	3:  { description: "Finance"},
	4:  { description: "Legal"},
	5:  { description: "Customer Service"},
	6:  { description: "Human Resources"},
	7:  { description: "Purchasing"},
	8:  { description: "Marketing"},
	9:  { description: "Operations"},
	10: { description: "Quality"},
	11: { description: "Executive"},
};
export default departments;
